
const LAYOUT = Object.freeze({
  APP_BAR_HEIGHT: 72
});

const BREAKPOINTS = Object.freeze({
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
});

module.exports = {
  LAYOUT,
  BREAKPOINTS
};
